import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import { ITestableComponentProps } from "@formant/core/model/ITestableComponentProps";

import { Heading2 } from "./Heading2";
import * as styles from "./Section.scss";

export interface ISectionProps extends ITestableComponentProps {
    title: string;
    className?: string;
    extra?: ReactNode;
    actions?: ReactNode;
    children?: React.ReactNode;
}

export class Section extends Component<ISectionProps> {
    public render() {
        const { title, className, extra, actions, children } = this.props;

        return (
            <div className={classnames(styles.section, className)}>
                <div className={styles.heading}>
                    <Heading2 data-testid="section-title">{title}</Heading2>
                    {extra && <div className={styles.extra}>{extra}</div>}
                    {actions && <div className={styles.actions}>{actions}</div>}
                </div>
                {children}
            </div>
        );
    }
}
